const INITIAL_STATE = {
  bancos: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'BANCOS_FETCHED':
      return { ...state, bancos: action.payload }
    default:
      return state
  }
}